import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { useState } from 'react';

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 w-full z-50 bg-black/80 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2">
            <h1 className="text-2xl font-bold text-[#D4AF37] tracking-wide">
              Magic Touch
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            <div className="flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm uppercase tracking-widest transition-colors duration-300 font-medium ${
                    isActive(link.path)
                      ? 'text-[#D4AF37]'
                      : 'text-white hover:text-[#D4AF37]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
            <a
              href="tel:+919870214490"
              className="flex items-center gap-2 bg-[#D4AF37] text-black px-6 py-2.5 uppercase tracking-widest text-sm font-semibold hover:bg-[#E5C15D] transition-all duration-300"
            >
              <Phone size={16} />
              <span>Call Now</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-[#D4AF37]"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-6 space-y-5 animate-in slide-in-from-top duration-300">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block text-sm uppercase tracking-widest transition-colors duration-300 font-medium ${
                  isActive(link.path)
                    ? 'text-[#D4AF37]'
                    : 'text-white hover:text-[#D4AF37]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:+919870214490"
              className="flex items-center gap-2 bg-[#D4AF37] text-black px-6 py-2.5 uppercase tracking-widest text-sm font-semibold hover:bg-[#E5C15D] transition-all duration-300 w-fit"
            >
              <Phone size={16} />
              <span>Call Now</span>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};
